import { CourseMetricsCardsProps } from '../../types/courseAnalytics.types';

export function CourseMetricsCards({ metrics }: CourseMetricsCardsProps) {
    return (
        <div className='grid grid-cols-2 md:w-1/4 md:grid-cols-1 md:gap-4 md:px-0 md:pt-8'>
            <div className='border-disabled col-span-2 flex flex-col justify-between rounded-none border-b p-6 md:col-span-1 md:rounded-lg md:border'>
                <small className='text-gray text-label-sm-bold'>Users</small>
                <span className='text-brand-strong text-display-display2'>{metrics.totalEnrollment}</span>
            </div>

            <div className='border-disabled col-span-1 flex flex-col justify-between rounded-none border-b p-6 md:rounded-lg md:border'>
                <small className='text-gray text-label-sm-bold'>Completion Rate</small>
                <span className='text-brand-strong text-display-display2'>{metrics.overallCompletionRate}%</span>
            </div>
            <div className='border-disabled flex flex-col justify-between rounded-none border-b border-l p-6 md:rounded-lg md:border'>
                <small className='text-gray text-label-sm-bold'>Lessons Completed</small>
                <span className='text-brand-strong text-display-display2'>{metrics.totalLessonsCompleted}</span>
            </div>
        </div>
    );
}
